export default __webpack_public_path__ + "static/professor-4-c9b652df29f2dbcca94b269f2b1ddd0f.png";